import React, { useMemo } from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import Grow from "@mui/material/Grow";
import Collapse from "@mui/material/Collapse";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { TEXT } from "./constants";
import { SystemProps } from "@mui/system";

interface ErrorStateProps {
  errors: string[];
  onReset: () => void;
}

const errorContainerStyles: SystemProps = {
  fontSize: "large",
  color: "error.main",
  width: 300,
  padding: 1.5,
  borderRadius: 1,
  border: "1px solid",
  borderColor: "error.light",
  bgcolor: "error.lightest",
};

const errorListStyles: SystemProps = {
  flexDirection: "column",
  alignItems: "flex-start",
  gap: 1,
  paddingLeft: 2,
  margin: 0,
  color: "error.dark",
};

export const ErrorState: React.FC<ErrorStateProps> = ({ errors, onReset }) => {
  const errorMessages = useMemo(() => {
    if (errors.length === 0) return [TEXT.UNKNOWN_ERROR];

    return errors;
  }, [errors]);

  return (
    <Box>
      <Grow in={true} timeout={500}>
        <Stack
          direction="column"
          justifyContent="center"
          alignItems="center"
          spacing={1}
        >
          <ErrorOutlineIcon fontSize="large" color="error" />
          <Typography
            variant="body2"
            align="center"
            color="error"
            fontWeight="medium"
          >
            {TEXT.ERROR_CSV_VALIDATION}
          </Typography>

          <Collapse in={true} timeout={700}>
            <Box {...errorContainerStyles}>
              <Stack {...errorListStyles} component="ul">
                {errorMessages.map((error, index) => (
                  <Box component="li" key={index} paddingLeft={0.5}>
                    <Typography variant="body2" color="error.dark">
                      {error}
                    </Typography>
                  </Box>
                ))}
              </Stack>
            </Box>
          </Collapse>

          <Box marginTop={2}>
            <Button variant="outlined" color="error" onClick={onReset}>
              {TEXT.TRY_AGAIN_BUTTON}
            </Button>
          </Box>
        </Stack>
      </Grow>
    </Box>
  );
};
